import { gql, TypedDocumentNode } from "@apollo/client";

import { BlacklistElementFragment } from "src/graphql/anti-fraud/__generated__/graphql";
import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment";
import { blacklistFragment } from "src/graphql/anti-fraud/fragments/BlacklistFragment";
import { propertyValueFragment } from "src/graphql/anti-fraud/fragments/PropertyValueFragment";

export const blacklistElementFragment = gql`
  fragment BlacklistElement on BlacklistElement {
    id
    disabled
    properties {
      ...PropertyValueFragment
    }
    sourceCaseType {
      name
    }
    blacklist {
      ...BlacklistFragment
    }
    adminStatus {
      ...AdminStatus
    }
    origin
  }

  ${blacklistFragment}
  ${propertyValueFragment}
  ${adminStatusFragment}
` as TypedDocumentNode<BlacklistElementFragment>;
